import { CommonConfig } from '../configs/config.common';

export namespace BrowserService {
    export function isWWW() {
        const config = new CommonConfig();
        // console.log(config.worldWide instanceof Array, 'config.worldWide instanceof Array');
        // console.log(typeof config.worldWide === 'string', `typeof config.worldWide === 'string'`);
        if (config.wwwDebugMode) {
            // debugMode
            return true;
        }
        let is = false;
        if (config.worldWide instanceof Array) {
            config.worldWide.map((hostName: string) => {
                if (window.location.hostname.indexOf(hostName) >= 0) {
                    is = true;
                }
            });
        } else if (typeof config.worldWide === 'string') {
            is = window.location.hostname.indexOf(config.worldWide) >= 0;
        } else {
            console.error('Invalid woldWide Configuration.');
        }
        return is;
    }
}
